exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "\n.dateToCalendar .vdp-datepicker__calendar {\n  right: 0;\n}\n.click-to-open {\n  position: relative;\n}\n.click-to-open .select-drawer {\n    width: auto;\n    background-color: #fff;\n    top: 100%;\n    position: absolute;\n    z-index: 1;\n    box-shadow: 0 2px 6px 0 #8ca0b3;\n}\n.click-to-open .select-drawer.left {\n      right: 0;\n}\n.click-to-open .select-drawer li {\n      white-space: nowrap;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":false,"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"id":"data-v-5bf0b1b9","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=1!./src/components/reports/createReport/createReport.vue
// module id = 2941
// module chunks = 0